<template>
    <span class="block overflow-hidden text-ellipsis">{{ displayName }}</span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    name?: string | null;
}>();

const displayName = computed(() => {
    if (!props.name) return '-';
    // Capitalize first letter
    return String(props.name).charAt(0).toUpperCase() + String(props.name).slice(1);
});
</script>
